import type {SuggestObject} from '@yandex-delivery/api/model/suggest'
import {Box, Slot, Text, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'

import * as classes from './SuggestPayload.classes'

type SuggestPayloadProps = {changeHandler: (address: SuggestObject) => void; items: SuggestObject[]}

export function SuggestPayload({changeHandler, items}: SuggestPayloadProps) {
  const i18n = useI18n()
  if (!items.length) {
    return (
      <Box justifyContent="center" p="m">
        <Typography color="minor" variant="body2">
          {i18n('bdui.pickup_points.suggest.no_results', 'Ничего не найдено')}
        </Typography>
      </Box>
    )
  }

  return (
    <>
      {items.map(item => (
        <Slot
          key={item.uri || item.text}
          className={classes.slot}
          onClick={() => {
            changeHandler(item)
          }}
          py="xs"
          size="l"
        >
          <Text>
            <Typography variant="body2">{item.title.text}</Typography>
            {item.subtitle && (
              <Typography color="minor" variant="caption1">
                {item.subtitle.text}
              </Typography>
            )}
          </Text>
          {item.distance && (
            <Text
              // @ts-expect-error Property 'alignItems' does not exist on type...
              alignItems="flex-end"
              className={classes.suggestTrail}
              color="minor"
              Component={Typography}
              ml="s"
              variant="caption1"
            >
              {item.distance.text}
            </Text>
          )}
        </Slot>
      ))}
    </>
  )
}
